import router from '@/router'
import { resetRouter } from '@/router'

//根据项目需求进行修改
export default{
  getLoginInfo(){
    var userInfo = {};
    userInfo.token = sessionStorage.getItem("token");
    userInfo.USER_DESC = sessionStorage.getItem("USER_DESC");
    userInfo.LOGIN_NAME = sessionStorage.getItem("LOGIN_NAME");
    return userInfo;
  },
  getMenus(){
    let menus = sessionStorage.getItem('menus')
    if(menus){
      try {
        menus = JSON.parse(menus)
      } catch (error) {
        menus = []        
      }
    }
    return menus
  },
  saveMenus(menus){
    sessionStorage.setItem('menus',JSON.stringify(menus))
  },
  saveLoginInfo(data){
    sessionStorage.setItem("token",data.token_type + ' ' + data.access_token);
    sessionStorage.setItem("USER_DESC",data.profile.given_name);
    sessionStorage.setItem("LOGIN_NAME",data.profile.sub);
  },
  clearLoginInfo(){
    localStorage.removeItem("token");
    sessionStorage.removeItem("token");
    sessionStorage.removeItem("USER_DESC");
    sessionStorage.removeItem("LOGIN_NAME");
    sessionStorage.removeItem("showTipOnlyOnce");
    sessionStorage.removeItem("userInfo");
    sessionStorage.removeItem("zoom");
  },
  goLoginPage(){
    resetRouter()
    router.options.isAddDynamicMenuRoutes = false
    router.replace({name: 'login'})
  }
}